module.exports = __webpack_public_path__ + "media/duplicate_scan_notification.5e28b46e.wav";